/* eslint-disable quote-props */

const th = {
  translations: {
    // nhc menu
    'คลังข้อมูลน้ำแห่งชาติ': 'คลังข้อมูลน้ำแห่งชาติ',

    // top menu
    'ภาพรวมประเทศไทย': 'ภาพรวมประเทศไทย',
    'แนะนำการใช้งาน': 'แนะนำการใช้งาน',
    'เกี่ยวกับเรา': 'เกี่ยวกับเรา',
    'ติดต่อเรา': 'ติดต่อเรา',

    // main menu
    'ฝน 24 ชม.': 'ฝน 24 ชม.',
    'ระดับน้ำ': 'ระดับน้ำ',
    'แหล่งน้ำ': 'แหล่งน้ำ',
    'คุณภาพน้ำ': 'คุณภาพน้ำ',
    'พื้นที่ประกาศภัย': 'พื้นที่ประกาศภัย',
    'พายุ': 'พายุ',
    'เรดาร์': 'เรดาร์',
    'คาดการณ์ฝน': 'คาดการณ์ฝน',
    'คาดการณ์คลื่น': 'คาดการณ์คลื่น',
    'คาดการณ์น้ำท่วมฉับพลัน': 'คาดการณ์น้ำท่วมฉับพลัน',
    'คาดการณ์ความเค็ม': 'คาดการณ์ความเค็ม',
    'ติดตามภัยแล้ง': 'ติดตามภัยแล้ง',
    'รายละเอียด': 'รายละเอียด',
    'เตือนภัยน้ำหลากดินถล่ม': 'เตือนภัยน้ำหลากดินถล่ม',
    'เตือนภัยน้ำหลากดินถล่ม (EWS)': 'เตือนภัยน้ำหลากดินถล่ม (EWS)',

    // sidebar menu
    'ดูข้อมูล': 'ดูข้อมูล',
    'สำหรับเจ้าหน้าที่': 'สำหรับเจ้าหน้าที่',
    'เปลี่ยนรหัสผ่าน': 'เปลี่ยนรหัสผ่าน',
    'เข้าระบบหลังบ้าน': 'เข้าระบบหลังบ้าน',
    'ชื่อผู้ใช้งาน': 'ชื่อผู้ใช้งาน',
    'รหัสผ่าน': 'รหัสผ่าน',
    'ลืมรหัสผ่าน': 'ลืมรหัสผ่าน',
    'รหัสผ่านเดิม': 'รหัสผ่านเดิม',
    'รหัสผ่านใหม่': 'รหัสผ่านใหม่',
    'ยืนยันรหัสผ่านใหม่': 'ยืนยันรหัสผ่านใหม่',
    'ตกลง': 'ตกลง',
    'เข้าสู่ระบบ': 'เข้าสู่ระบบ',
    'ออกจากระบบ': 'ออกจากระบบ',
    'ระบบได้ส่งลิงค์ยืนยันตั้งรหัสผ่านใหม่ของคุณ ทางอีเมล์เรียบร้อยแล้ว': 'ระบบได้ส่งลิงค์ยืนยันตั้งรหัสผ่านใหม่ของคุณ ทางอีเมล์เรียบร้อยแล้ว',
    'กรุณายืนยัน': 'กรุณายืนยัน',
    'ป้อนอีเมล์ของคุณ': 'ป้อนอีเมล์ของคุณ',

    // model menu
    'ข้อมูลคาดการณ์จากแบบจำลอง': 'ข้อมูลคาดการณ์จากแบบจำลอง',
    'ระบบเตือนภัยน้ำท่วมฉับพลันด้วยค่าดัชนีศักยภาพการเกิดน้ำท่วมฉับพลัน': 'ระบบเตือนภัยน้ำท่วมฉับพลันด้วยค่าดัชนีศักยภาพการเกิดน้ำท่วมฉับพลัน',
    'ระบบวิเคราะห์ปริมาณฝนสูงสุดรายอำเภอ': 'ระบบวิเคราะห์ปริมาณฝนสูงสุดรายอำเภอ',
    'ระบบประเมินปริมาณน้ำฝนและพยากรณ์ฝนล่วงหน้า': 'ระบบประเมินปริมาณน้ำฝนและพยากรณ์ฝนล่วงหน้า',
    'ระบบแสดงแผนที่ฝนคาดการณ์รายเดือน': 'ระบบแสดงแผนที่ฝนคาดการณ์รายเดือน',
    'ระบบติดตามภัยแล้ง': 'ระบบติดตามภัยแล้ง',
    'ระบบคาดการณ์ความเค็มรุกตัวในแม่น้ำเจ้าพระยาตอนล่าง': 'ระบบคาดการณ์ความเค็มรุกตัวในแม่น้ำเจ้าพระยาตอนล่าง',
    'ระบบคาดการณ์น้ำท่า': 'ระบบคาดการณ์น้ำท่า',

    // rain page
    'ฝน': 'ฝน',
    'ฝน 24 ชั่วโมง': 'ฝน 24 ชั่วโมง',
    'ฝนวันนี้': 'ฝนวันนี้',
    'ฝนวานนี้': 'ฝนวานนี้',
    'ฝน 3 วัน': 'ฝน 3 วัน',
    'ฝน 7 วัน': 'ฝน 7 วัน',
    'ฝนรายเดือน': 'ฝนรายเดือน',
    'ฝนรายปี': 'ฝนรายปี',
    'ฝนสะสม': 'ฝนสะสม',
    'ฝนสถิติ': 'ฝนสถิติ',
    'เกณฑ์ฝนสะสมรายปี': 'เกณฑ์ฝนสะสมรายปี',
    'แสดงเกณฑ์ฝนสะสมรายปี': 'แสดงเกณฑ์ฝนสะสมรายปี',
    'ฝนล่าสุด': 'ฝนล่าสุด',
    '(มม.)': '(มม.)',
    'เดือน-ปี': 'เดือน-ปี',
    'เดือน': 'เดือน',
    'ฝนสะสม 24 ชม. ย้อนหลัง': 'ฝนสะสม 24 ชม. ย้อนหลัง',
    'ปริมาณฝนสะสมตั้งแต่เวลาปัจจุบันย้อนหลังไป 24 ชั่วโมง': 'ปริมาณฝนสะสมตั้งแต่เวลาปัจจุบันย้อนหลังไป 24 ชั่วโมง',
    'ปริมาณฝนสะสมตั้งแต่เวลา 7.00 น. ของวันนี้ จนถึงเวลาปัจจุบันของวันนี้': 'ปริมาณฝนสะสมตั้งแต่เวลา 7.00 น. ของวันนี้ จนถึงเวลาปัจจุบันของวันนี้',
    'ปริมาณฝนสะสมที่เกิดขึ้นตั้งแต่ 7.00 น. ของวันก่อนหน้าถึง 7.00 น. ของวันปัจจุบัน': 'ปริมาณฝนสะสมที่เกิดขึ้นตั้งแต่ 7.00 น. ของวันก่อนหน้าถึง 7.00 น. ของวันปัจจุบัน',
    'ผลรวมของฝนรายวันจำนวน 3 วัน': 'ผลรวมของฝนรายวันจำนวน 3 วัน',
    'ผลรวมของฝนรายวันจำนวน 7 วัน': 'ผลรวมของฝนรายวันจำนวน 7 วัน',
    'เกณฑ์ฝน': 'เกณฑ์ฝน',
    'ฝนสะสม 24 ชม (มม.)': 'ฝนสะสม 24 ชม (มม.)',
    'ฝนสะสม (มม.)': 'ฝนสะสม (มม.)',
    'ฝนสะสม 1 ชม (มม.)': 'ฝนสะสม 1 ชม (มม.)',
    'นับเฉพาะขั้นวิกฤติ': 'นับเฉพาะขั้นวิกฤติ',
    'ดาวน์โหลดไฟล์ ฝน': 'ดาวน์โหลดไฟล์ ฝน',
    'ปริมาณฝน (มม.)': 'ปริมาณฝน (มม.)',
    'ฝนมาก': 'ฝนมาก',
    'ฝนน้อย': 'ฝนน้อย',
    'เกณฑ์': 'เกณฑ์',
    'เกณฑ์ฝนสะสม 3 วัน': 'เกณฑ์ฝนสะสม 3 วัน',
    'แสดงเกณฑ์ฝน 3 วัน': 'แสดงเกณฑ์ฝน 3 วัน',
    'แสดงเกณฑ์': 'แสดงเกณฑ์',
    'กราฟฝนสะสม 3 วัน': 'กราฟฝนสะสม 3 วัน',
    'ดาวน์โหลดข้อมูล ฝน 3 วัน': 'ดาวน์โหลดข้อมูล ฝน 3 วัน',
    'กราฟฝนสะสม 7 วัน': 'กราฟฝนสะสม 7 วัน',
    'ดาวน์โหลดข้อมูล ฝน 7 วัน': 'ดาวน์โหลดข้อมูล ฝน 7 วัน',
    'ไม่มีข้อมูลฝน': 'ไม่มีข้อมูลฝน',
    'ดาวน์โหลดข้อมูล ฝน 24 ชั่วโมง': 'ดาวน์โหลดข้อมูล ฝน 24 ชั่วโมง',
    'ดาวน์โหลดข้อมูล ฝนรายเดือน': 'ดาวน์โหลดข้อมูล ฝนรายเดือน',
    'กราฟฝน': 'กราฟฝน',
    'ดาวน์โหลดข้อมูล ฝนรายปี': 'ดาวน์โหลดข้อมูล ฝนรายปี',
    'ดาวน์โหลดข้อมูล ฝนวันนี้': 'ดาวน์โหลดข้อมูล ฝนวันนี้',
    'ดาวน์โหลดข้อมูล ฝนวานนี้': 'ดาวน์โหลดข้อมูล ฝนวานนี้',
    'ปริมาณฝน': 'ปริมาณฝน',
    'ปริมาณฝนสะสม 7 วัน': 'ปริมาณฝนสะสม 7 วัน',
    'ปริมาณฝนสะสม 3 วัน': 'ปริมาณฝนสะสม 3 วัน',
    'ปริมาณฝนสะสมรายวัน': 'ปริมาณฝนสะสมรายวัน',
    'ปริมาณฝนรายวัน': 'ปริมาณฝนรายวัน',
    'ปริมาณฝนวันนี้': 'ปริมาณฝนวันนี้',
    'ปริมาณฝนรายชั่วโมง': 'ปริมาณฝนรายชั่วโมง',
    'ปริมาณฝนสะสม': 'ปริมาณฝนสะสม',
    'ภาพ isohyet': 'ภาพ isohyet',
    'ไม่มีข้อมูลฝนรายชั่วโมง': 'ไม่มีข้อมูลฝนรายชั่วโมง',

    // dam page
    'แหล่งน้ำขนาดใหญ่': 'แหล่งน้ำขนาดใหญ่',
    'แหล่งน้ำขนาดใหญ่ กรมชลฯ': 'แหล่งน้ำขนาดใหญ่ กรมชลฯ',
    'แหล่งน้ำขนาดใหญ่ การไฟฟ้า': 'แหล่งน้ำขนาดใหญ่ การไฟฟ้า',
    'แหล่งน้ำขนาดกลาง': 'แหล่งน้ำขนาดกลาง',
    'ภาพรวมสถานการณ์ล่าสุด': 'ภาพรวมสถานการณ์ล่าสุด',
    'สถิติแหล่งน้ำขนาดใหญ่': 'สถิติแหล่งน้ำขนาดใหญ่',
    'สถิติแหล่งน้ำขนาดกลาง': 'สถิติแหล่งน้ำขนาดกลาง',
    'แสดงทุกปริมาณน้ำ': 'แสดงทุกปริมาณน้ำ',
    'อ่างขนาดใหญ่': 'อ่างขนาดใหญ่',
    'อ่างขนาดกลาง': 'อ่างขนาดกลาง',
    'อ่างเก็บน้ำ': 'อ่างเก็บน้ำ',
    'ความจุ': 'ความจุ',
    'ความจุที่ รนก.': 'ความจุที่ รนก.',
    'ความจุน้ำใช้การ': 'ความจุน้ำใช้การ',
    'ปริมาณน้ำ': 'ปริมาณน้ำ',
    'ปริมาตรใช้การ': 'ปริมาตรใช้การ',
    'ปริมาตรน้ำใช้การ': 'ปริมาตรน้ำใช้การ',
    'น้ำไหลลง': 'น้ำไหลลง',
    'น้ำระบาย': 'น้ำระบาย',
    'ปริมาณน้ำกักเก็บ': 'ปริมาณน้ำกักเก็บ',
    'น้ำไหลลง / ระบาย': 'น้ำไหลลง / ระบาย',
    'ล้าน ลบ.ม': 'ล้าน ลบ.ม',
    ' ล้าน ลบ.ม.': ' ล้าน ลบ.ม.',
    'ล้าน ลบ.ม (% ความจุ)': 'ล้าน ลบ.ม (% ความจุ)',
    'ล้าน ลบ.ม. (% ความจุ)': 'ล้าน ลบ.ม. (% ความจุ)',
    'ล้าน ลบ.ม (% น้ำใช้การได้)': 'ล้าน ลบ.ม (% น้ำใช้การได้)',
    'ล้าน ลบ.ม. (%น้ำใช้การ)': 'ล้าน ลบ.ม. (%น้ำใช้การ)',
    '(% ความจุที่ รนก.)': '(% ความจุที่ รนก.)',
    '(% ความจุน้ำใช้การ)': '(% ความจุน้ำใช้การ)',
    'ประเภทข้อมูล': 'ประเภทข้อมูล',
    'ปี (สูงสุด 8 ปี)': 'ปี (สูงสุด 8 ปี)',
    'ไม่มีข้อมูลแหล่งน้ำขนาดใหญ่ ตามเงื่อนไข': 'ไม่มีข้อมูลแหล่งน้ำขนาดใหญ่ ตามเงื่อนไข',
    'ที่ รนส.': 'ที่ รนส.',
    'ที่ รนก.': 'ที่ รนก.',
    'ที่ น้ำใช้การ': 'ที่น้ำใช้การ',
    'พิ้นที่': 'พิ้นที่',
    'น้ำในอ่าง': 'น้ำในอ่าง',
    'ปริมาณน้ำไหลลงอ่าง': 'ปริมาณน้ำไหลลงอ่าง',
    'ปริมาณน้ำระบาย': 'ปริมาณน้ำระบาย',
    'ค่าเฉลี่ยรวมทั้งปี': 'ค่าเฉลี่ยรวมทั้งปี',
    'ปริมาตรน้ำ': 'ปริมาตรน้ำ',
    'สะสมตั้งแต่ 1 ม.ค.': 'สะสมตั้งแต่ 1 ม.ค.',
    'ภาคเหนือ': 'ภาคเหนือ',
    'รวมภาคเหนือ': 'รวมภาคเหนือ',
    'ภาคตะวันออกเฉียงเหนือ': 'ภาคตะวันออกเฉียงเหนือ',
    'รวมภาคตะวันออกเฉียงเหนือ': 'รวมภาคตะวันออกเฉียงเหนือ',
    'ภาคกลาง': 'ภาคกลาง',
    'รวมภาคกลาง': 'รวมภาคกลาง',
    'ภาคตะวันตก': 'ภาคตะวันตก',
    'รวมภาคตะวันตก': 'รวมภาคตะวันตก',
    'ภาคตะวันออก': 'ภาคตะวันออก',
    'รวมภาคตะวันออก': 'รวมภาคตะวันออก',
    'ภาคใต้': 'ภาคใต้',
    'รวมภาคใต้': 'รวมภาคใต้',
    'รวมทั้งประเทศ': 'รวมทั้งประเทศ',
    'คำย่อ': 'คำย่อ',
    'รนส. หมายถึง ระดับน้ำสูงสุด': 'รนส. หมายถึง ระดับน้ำสูงสุด',
    'รนก. หมายถึง ระดับน้ำกับเก็บ': 'รนก. หมายถึง ระดับน้ำกับเก็บ',
    'กักเก็บต่ำสุด': 'กักเก็บต่ำสุด',
    'น้ำน้อยวิกฤต (%น้ำใช้การฯ)': 'น้ำน้อยวิกฤต (%น้ำใช้การฯ)',
    'น้ำมากวิกฤต (%ความจุ)': 'น้ำมากวิกฤต (%ความจุ)',
    'ม.รทก.': 'ม.รทก.',
    'เกณฑ์แหล่งน้ำ': 'เกณฑ์แหล่งน้ำ',
    'ปริมาณน้ำกักเก็บปัจจุบัน (% รนก.)': 'ปริมาณน้ำกักเก็บปัจจุบัน (% รนก.)',
    'กราฟอ่างเก็บน้ำรายวัน กรมชลประทาน': 'กราฟอ่างเก็บน้ำรายวัน กรมชลประทาน',
    'กราฟอ่างเก็บน้ำรายวัน การไฟฟ้า': 'กราฟอ่างเก็บน้ำรายวัน การไฟฟ้า',
    'กราฟอ่างเก็บน้ำขนาดกลางรายวัน กรมชลประทาน': 'กราฟอ่างเก็บน้ำขนาดกลางรายวัน กรมชลประทาน',
    'ไม่มีข้อมูลแหล่งน้ำขนาดกลาง ตามเงื่อนไข': 'ไม่มีข้อมูลแหล่งน้ำขนาดกลาง ตามเงื่อนไข',
    'กราฟรายปี': 'กราฟรายปี',
    'รวม': 'รวม',
    'กักเก็บปกติ (ล้าน ลบ.ม.)': 'กักเก็บปกติ (ล้าน ลบ.ม.)',
    'กักเก็บต่ำสุด (ล้าน ลบ.ม.)': 'กักเก็บต่ำสุด (ล้าน ลบ.ม.)',
    'กักเก็บ (ล้าน ลบ.ม.)': 'กักเก็บ (ล้าน ลบ.ม.)',
    'กักเก็บ (% ความจุ)': 'กักเก็บ (% ความจุ)',
    'ปริมาตรใช้การ (ล้าน ลบ.ม.)': 'ปริมาตรใช้การ (ล้าน ลบ.ม.)',
    'น้ำไหลลง (ล้าน ลบ.ม.)': 'น้ำไหลลง (ล้าน ลบ.ม.)',
    'น้ำระบาย (ล้าน ลบ.ม.)': 'น้ำระบาย (ล้าน ลบ.ม.)',
    'ดาวน์โหลดไฟล์ อ่างเก็บน้ำ': 'ดาวน์โหลดไฟล์ อ่างเก็บน้ำ',
    'แหล่งน้ำอื่นๆ ที่เกี่ยวข้อง': 'แหล่งน้ำอื่นๆ ที่เกี่ยวข้อง',
    'รวมแหล่งน้ำอื่นๆ ที่เกี่ยวข้อง': 'รวมแหล่งน้ำอื่นๆ ที่เกี่ยวข้อง',
    'รวมแหล่งน้ำขนาดใหญ่': 'รวมแหล่งน้ำขนาดใหญ่',
    'รวมแหล่งน้ำขนาดกลาง': 'รวมแหล่งน้ำขนาดกลาง',
    'ดาวน์โหลดข้อมูล แหล่งน้ำขนาดกลาง': 'ดาวน์โหลดข้อมูล แหล่งน้ำขนาดกลาง',
    'ดาวน์โหลดข้อมูล แหล่งน้ำขนาดใหญ่': 'ดาวน์โหลดข้อมูล แหล่งน้ำขนาดใหญ่',
    'ความจุ (ล้าน ลบ.ม.)': 'ความจุ (ล้าน ลบ.ม.)',
    'ความจุอ่างที่ รนส. (ล้าน ลบ.ม.)': 'ความจุอ่างที่ รนส. (ล้าน ลบ.ม.)',
    'ความจุอ่างที่ รนก. (ล้าน ลบ.ม.)': 'ความจุอ่างที่ รนก. (ล้าน ลบ.ม.)',
    'ความจุอ่างที่ น้ำใช้การ (ล้าน ลบ.ม.)': 'ความจุอ่างที่ น้ำใช้การ (ล้าน ลบ.ม.)',
    'คิดเป็น % ของน้ำเต็มอ่าง': 'คิดเป็น % ของน้ำเต็มอ่าง',
    'น้ำในอ่าง กักเก็บ (ล้าน ลบ.ม.)': 'น้ำในอ่าง กักเก็บ (ล้าน ลบ.ม.)',
    'น้ำในอ่าง กักเก็บ (% ความจุ)': 'น้ำในอ่าง กักเก็บ (% ความจุ)',
    'น้ำในอ่าง ปริมาตรใช้การ (ล้าน ลบ.ม.)': 'น้ำในอ่าง ปริมาตรใช้การ (ล้าน ลบ.ม.)',
    'น้ำในอ่าง ปริมาตรใช้การ (% ความจุ)': 'น้ำในอ่าง ปริมาตรใช้การ (% ความจุ)',
    'ปริมาณน้ำไหลลงอ่าง ค่าเฉลี่ยรวมทั้งปี (ล้าน ลบ.ม.)': 'ปริมาณน้ำไหลลงอ่าง ค่าเฉลี่ยรวมทั้งปี (ล้าน ลบ.ม.)',
    'ปริมาณน้ำไหลลงอ่าง ปริมาตรน้ำ (ล้าน ลบ.ม.)': 'ปริมาณน้ำไหลลงอ่าง ปริมาตรน้ำ (ล้าน ลบ.ม.)',
    'ปริมาณน้ำไหลลงอ่าง สะสมตั้งแต่ 1 ม.ค. (ล้าน ลบ.ม.)': 'ปริมาณน้ำไหลลงอ่าง สะสมตั้งแต่ 1 ม.ค. (ล้าน ลบ.ม.)',
    'ปริมาณน้ำไหลลงอ่าง สะสมตั้งแต่ 1 ม.ค. (% ความจุ)': 'ปริมาณน้ำไหลลงอ่าง สะสมตั้งแต่ 1 ม.ค. (% ความจุ)',
    'ปริมาณน้ำระบาย ปริมาตรน้ำ (ล้าน ลบ.ม.)': 'ปริมาณน้ำระบาย ปริมาตรน้ำ (ล้าน ลบ.ม.)',
    'ปริมาณน้ำระบาย สะสมตั้งแต่ 1 ม.ค. (ล้าน ลบ.ม.)': 'ปริมาณน้ำระบาย สะสมตั้งแต่ 1 ม.ค. (ล้าน ลบ.ม.)',
    'กราฟอ่างเก็บน้ำรายวัน รายภาค กรมชลประทาน': 'กราฟอ่างเก็บน้ำรายวัน รายภาค กรมชลประทาน',
    'กราฟอ่างเก็บน้ำรายวัน รายภาค การไฟฟ้า': 'กราฟอ่างเก็บน้ำรายวัน รายภาค การไฟฟ้า',
    'ปริมาณน้ำเก็บกัก': 'ปริมาณน้ำเก็บกัก',
    'ปริมาณน้ำใช้การ': 'ปริมาณน้ำใช้การ',
    'ปริมาณน้ำไหลลง': 'ปริมาณน้ำไหลลง',
    'ปริมาณน้ำไหลลงสะสม': 'ปริมาณน้ำไหลลงสะสม',
    'ปริมาณน้ำระบายสะสม': 'ปริมาณน้ำระบายสะสม',
    'เปรียบเทียบวันที่': 'เปรียบเทียบวันที่',
    'น้ำใช้การได้': 'น้ำใช้การได้',
    'กักเก็บสูงสุด': 'กักเก็บสูงสุด',
    'กักเก็บปกติ': 'กักเก็บปกติ',
    'ปริมาณน้ำไหลเข้าสะสม': 'ปริมาณน้ำไหลเข้าสะสม',

    // wl page
    '(ม.รทก)': '(ม.รทก)',
    'ระดับน้ำในแม่น้ำ': 'ระดับน้ำในแม่น้ำ',
    'ระดับน้ำ ปตร./ฝาย': 'ระดับน้ำ ปตร./ฝาย',
    'ระดับน้ำเหนือ': 'ระดับน้ำเหนือ',
    'ระดับน้ำท้าย': 'ระดับน้ำท้าย',
    'น้ำระบายสูงสุดปัจจุบัน': 'น้ำระบายสูงสุดปัจจุบัน',
    'กล้อง CCTV': 'กล้อง CCTV',
    'หน่วยงาน': 'หน่วยงาน',
    'ทุกหน่วยงาน': 'ทุกหน่วยงาน',
    'สถานการณ์': 'สถานการณ์',
    'ทุกสถานการณ์': 'ทุกสถานการณ์',
    'สถานีหลัก': 'สถานีหลัก',
    'ระดับตลิ่ง': 'ระดับตลิ่ง',
    'ค่าศูนย์เสาระดับ': 'ค่าศูนย์เสาระดับ',
    '% ความจุลำน้ำ': '% ความจุลำน้ำ',
    'ความจุลำน้ำ': 'ความจุลำน้ำ',
    'ล้นตลิ่ง': 'ล้นตลิ่ง',
    'สูงกว่าตลิ่ง': 'สูงกว่าตลิ่ง',
    'ต่ำกว่าตลิ่ง': 'ต่ำกว่าตลิ่ง',
    'ระดับน้ำปตร': 'ระดับน้ำปตร',
    'ภาพ': 'ภาพ',
    'ระดับท้องน้ำ': 'ระดับท้องน้ำ',
    'ปริมาณความจุลำน้ำ': 'ปริมาณความจุลำน้ำ',
    'เกณฑ์ระดับน้ำ': 'เกณฑ์ระดับน้ำ',
    'กราฟระดับน้ำ': 'กราฟระดับน้ำ',
    'กราฟระดับน้ำปตร./ฝาย': 'กราฟระดับน้ำปตร./ฝาย',
    'ปตร./ฝาย': 'ปตร./ฝาย',
    'ดาวน์โหลดข้อมูล CCTV': 'ดาวน์โหลดข้อมูล CCTV',
    'แสดงข้อมูล CCTV': 'แสดงข้อมูล CCTV',
    'ดาวน์โหลดข้อมูล ระดับน้ำปตร.': 'ดาวน์โหลดข้อมูล ระดับน้ำปตร.',
    'คลิ๊กเพื่อแสดงกราฟ': 'คลิ๊กเพื่อแสดงกราฟ',
    'ดาวน์โหลดข้อมูล ระดับน้ำ': 'ดาวน์โหลดข้อมูล ระดับน้ำ',
    'ดูภาพ / วีดีโอ': 'ดูภาพ / วีดีโอ',
    'จุดที่มีระดับน้ำสูงสุด': 'จุดที่มีระดับน้ำสูงสุด',
    'ต่ำสุด': 'ต่ำสุด',
    'โทรมาตร': 'โทรมาตร',
    'คลอง': 'คลอง',

    // waterquality page
    'กรด-ด่าง': 'กรด-ด่าง',
    'กรดด่าง': 'กรดด่าง',
    'ความเค็ม': 'ความเค็ม',
    'ความขุ่น': 'ความขุ่น',
    'สารละลาย': 'สารละลาย',
    'ออกซิเจน': 'ออกซิเจน',
    'พารามิเตอร์': 'พารามิเตอร์',
    'สถานีคุณภาพน้ำ': 'สถานีคุณภาพน้ำ',
    'เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา': 'เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา',
    'เกณฑ์ปกติ': 'เกณฑ์ปกติ',
    'เกินเกณฑ์มาตรฐานน้ำใช้เพื่อการเกษตร': 'เกินเกณฑ์มาตรฐานน้ำใช้เพื่อการเกษตร',
    'เกณฑ์เฝ้าระวังคุณภาพน้ำเพื่อการผลิตน้ำประปา': 'เกณฑ์เฝ้าระวังคุณภาพน้ำเพื่อการผลิตน้ำประปา',
    'เกณฑ์คุณภาพน้ำ': 'เกณฑ์คุณภาพน้ำ',
    'เปรียบเทียบสถานีคุณภาพน้ำ': 'เปรียบเทียบสถานีคุณภาพน้ำ',
    'แสดงตำแหน่งบนแผนที่': 'แสดงตำแหน่งบนแผนที่',
    'คลิ๊กเพื่อแสดงกราฟคุณภาพน้ำ': 'คลิ๊กเพื่อแสดงกราฟคุณภาพน้ำ',
    'ดาวน์โหลดข้อมูลคุณภาพน้ำ': 'ดาวน์โหลดข้อมูลคุณภาพน้ำ',
    'มากกว่า 2 เกินเกณฑ์มาตรฐานน้ำใช้เพื่อการเกษตร': 'มากกว่า 2 เกินเกณฑ์มาตรฐานน้ำใช้เพื่อการเกษตร',
    'มากกว่า 0.5 เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา': 'มากกว่า 0.5 เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา',
    'มากกว่า 0.25 เกณฑ์เฝ้าระวังคุณภาพน้ำเพื่อการผลิตน้ำประปา': 'มากกว่า 0.25 เกณฑ์เฝ้าระวังคุณภาพน้ำเพื่อการผลิตน้ำประปา',
    'น้อยกว่า 5 เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา': 'น้อยกว่า 5 เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา',
    'มากกว่า 9 เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา': 'มากกว่า 9 เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา',
    'ความเค็ม(g/L)': 'ความเค็ม(g/L)',
    'ออกซิเจนในน้ำ(mg/L)': 'ออกซิเจนในน้ำ(mg/L)',
    'กรด-ด่าง(pH)': 'กรด-ด่าง(pH)',
    'ความขุ่น(ntu)': 'ความขุ่น(ntu)',
    'สารละลาย(mg/L)': 'สารละลาย(mg/L)',
    'คำอธิบาย': 'คำอธิบาย',

    // risk page
    'ขอบเขตพื้นที่ประกาศภัย': 'ขอบเขตพื้นที่ประกาศภัย',
    'รายงานการให้ความช่วยเหลือ': 'รายงานการให้ความช่วยเหลือ',
    'ภาพรวมทั้งประเทศ': 'ภาพรวมทั้งประเทศ',
    'ฝนสะสม 1 วัน': 'ฝนสะสม 1 วัน',
    'ฝนสะสม 2 วัน': 'ฝนสะสม 3 วัน',
    'ฝนสะสม 3 วัน': 'ฝนสะสม 3 วัน',
    'ฝนสะสม 7 วัน': 'ฝนสะสม 7 วัน',
    'ฝนสะสม 15 วัน': 'ฝนสะสม 15 วัน',
    'ฝนสะสม 30 วัน': 'ฝนสะสม 30 วัน',
    'อุณหภูมิในรอบสัปดาห์': 'อุณหภูมิในรอบสัปดาห์',
    'สูงสุด': 'สูงสุด',
    'ปริมาณน้ำใช้การรวม เขื่อนหลัก วันนี้ปีที่ผ่านมา': 'ปริมาณน้ำใช้การรวม เขื่อนหลัก วันนี้ปีที่ผ่านมา',
    'ฝนสูงสุดวานนี้': 'ฝนสูงสุดวานนี้',
    'อุณหภูมิในรอบสัปดาห์  สูงสูด': 'อุณหภูมิในรอบสัปดาห์  สูงสูด',
    'ปริมาตรน้ำใช้การของแหล่งน้ำในจังหวัด': 'ปริมาตรน้ำใช้การของแหล่งน้ำในจังหวัด',
    'วันนี้ปีที่ผ่านมา (ล้าน ลบ.ม/% น้ำใช้การ)': 'วันนี้ปีที่ผ่านมา (ล้าน ลบ.ม/% น้ำใช้การ)',
    'เครื่องมือและอุปกรณ์': 'เครื่องมือและอุปกรณ์',
    'ยังไม่มีการเชื่อมโยงข้อมูล': 'ยังไม่มีการเชื่อมโยงข้อมูล',
    'รวมแหล่งน้ำขนาดใหญ่และขนาดกลาง': 'รวมแหล่งน้ำขนาดใหญ่และขนาดกลาง',
    'ล้านลูกบาศก์เมตร': 'ล้านลูกบาศก์เมตร',
    'สถานีวัดระดับน้ำ': 'สถานีวัดระดับน้ำ',
    'น้ำใช้การ': 'น้ำใช้การ',
    'วันนี้': 'วันนี้',
    'พรุ่งนี้': 'พรุ่งนี้',
    'มะรืนนี้': 'มะรืนนี้',
    'ไม่มีฝน': 'ไม่มีฝน',
    'ปริมาณน้ำฝน': 'ปริมาณน้ำฝน',

    // storm page
    'แผนที่วิเคราะห์เส้นทาง และความแรงของพายุ': 'แผนที่วิเคราะห์เส้นทาง และความแรงของพายุ',
    'แผนที่เส้นทางพายุที่อาจส่งผลกระทบต่อประเทศไทย': 'แผนที่เส้นทางพายุที่อาจส่งผลกระทบต่อประเทศไทย',
    'ภาพเมฆที่ปกคลุมบริเวณประเทศไทย': 'ภาพเมฆที่ปกคลุมบริเวณประเทศไทย',
    'มหาสมุทรแปซิฟิก': 'มหาสมุทรแปซิฟิก',
    'มหาสมุทรอินเดีย': 'มหาสมุทรอินเดีย',
    'เกณฑ์พายุ': 'เกณฑ์พายุ',
    'ข้อมูลเกณฑ์พายุ': 'ข้อมูลเกณฑ์พายุ',
    'ไม่มีพายุ': 'ไม่มีพายุ',
    'ความเร็ว': 'ความเร็ว',
    'แผนที่พายุและความแรงพายุขณะนี้': 'แผนที่พายุและความแรงพายุขณะนี้',
    'ภาพพายุหมุนในอดีต': 'ภาพพายุหมุนในอดีต',
    'ความหมายและที่มาของชื่อพายุ': 'ความหมายและที่มาของชื่อพายุ',
    'ไม่พบข้อมูลพายุ ตามเงื่อนไข': 'ไม่พบข้อมูลพายุ ตามเงื่อนไข',
    'ค้นหาพายุ': 'ค้นหาพายุ',
    'เดือน (แสดงทุกเดือน)': 'เดือน (แสดงทุกเดือน)',
    'ปี (สูงสุด 5 ปี)': 'ปี (สูงสุด 5 ปี)',
    'รายชื่อพายุบริเวณมหาสมุทรอินเดียเหนือ': 'รายชื่อพายุบริเวณมหาสมุทรอินเดียเหนือ',
    'รายชื่อพายุบริเวณมหาสมุทรแปซิฟิกด้านตะวันตกตอนบนและทะเลจีนใต้': 'รายชื่อพายุบริเวณมหาสมุทรแปซิฟิกด้านตะวันตกตอนบนและทะเลจีนใต้',
    'ลำดับที่': 'ลำดับที่.',
    'หมายเหตุ': 'หมายเหตุ',
    'ชุดที่': 'ชุดที่',
    'ชื่อภาษาอังกฤษ': 'ชื่อภาษาอังกฤษ',
    'ชื่อพายุ': 'ชื่อพายุ',
    'ประเทศที่มาของชื่อ': 'ประเทศที่มาของชื่อ',
    'การตั้งชื่อพายุหมุนเขตร้อนจะหมุนเวียนกันไปตามลำดับ และอ่านออกเสียงชื่อพายุตามราชบัณฑิตยสภา': 'การตั้งชื่อพายุหมุนเขตร้อนจะหมุนเวียนกันไปตามลำดับ และอ่านออกเสียงชื่อพายุตามราชบัณฑิตยสภา',
    'รายชื่อพายุนี้แก้ไขปรับปรุงในการประชุมทางไกลผ่านจอภาพของคณะกรรมการไต้ฝุ่นครั้งที่ 53 ระหว่างวันที่ 23-25 กุมภาพันธ์ 2564': 'รายชื่อพายุนี้แก้ไขปรับปรุงในการประชุมทางไกลผ่านจอภาพของคณะกรรมการไต้ฝุ่นครั้งที่ 53 ระหว่างวันที่ 23-25 กุมภาพันธ์ 2564',
    'ส่วนวิจัยและความร่วมมือทางวิชาการ กองพัฒนาอุตุนิยมวิทยา/มีนาคม 2564': 'ส่วนวิจัยและความร่วมมือทางวิชาการ กองพัฒนาอุตุนิยมวิทยา/มีนาคม 2564',
    'เสนอชื่อโดยประเทศริมมหาสมุทรอินเดีย 13 ประเทศ ข้อมูลปี พ.ศ.2563': 'เสนอชื่อโดยประเทศริมมหาสมุทรอินเดีย 13 ประเทศ ข้อมูลปี พ.ศ.2563',

    // radar page
    'รัศมี 240 กม.': 'รัศมี 240 กม.',
    'รัศมี 160 กม.': 'รัศมี 160 กม.',
    'รัศมี 120 กม.': 'รัศมี 120 กม.',
    'ข้อมูลจากกรมอุตุนิยมวิทยา, กรมฝนหลวงการบินและการเกษตร, สำนักระบายน้ำ กรุงเทพมหานคร': 'ข้อมูลจากกรมอุตุนิยมวิทยา, กรมฝนหลวงการบินและการเกษตร, สำนักระบายน้ำ กรุงเทพมหานคร',

    // wave page
    'แผนภาพคาดการณ์ความสูงและทิศทางคลื่นล่วงหน้า 7 วัน ความละเอียดสูงจากแบบจำลองคลื่นทะเล (SWAN Model)': 'แผนภาพคาดการณ์ความสูงและทิศทางคลื่นล่วงหน้า 7 วัน ความละเอียดสูงจากแบบจำลองคลื่นทะเล (SWAN Model)',
    'แผนภาพคาดการณ์ความสูงและทิศทางคลื่นล่วงหน้า 7 วัน': 'แผนภาพคาดการณ์ความสูงและทิศทางคลื่นล่วงหน้า 7 วัน',
    'เกณฑ์ข้อมูลคลื่น': 'เกณฑ์ข้อมูลคลื่น',
    'คลื่นสูงมากกว่า 2 เมตร': 'คลื่นสูงมากกว่า 2 เมตร',

    // forecast rainfall
    'แผนภาพคาดการณ์ฝนล่วงหน้า 7 วัน ความละเอียดสูงจากแบบจำลองสภาพอากาศ WRF-ROMS Model โดย สสน.': 'แผนภาพคาดการณ์ฝนล่วงหน้า 7 วัน ความละเอียดสูงจากแบบจำลองสภาพอากาศ WRF-ROMS Model โดย สสน.',
    'แผนภาพคาดการณ์ฝนเชิงพื้นที่ จากแบบจำลองอากาศเชิงตัวเลขด้วยคอมพิวเตอร์สมรรถนะสูง (TMD-WRF) โดย กรมอุตุนิยมวิทยา': 'แผนภาพคาดการณ์ฝนเชิงพื้นที่ จากแบบจำลองอากาศเชิงตัวเลขด้วยคอมพิวเตอร์สมรรถนะสูง (TMD-WRF) โดย กรมอุตุนิยมวิทยา',
    '* โดยทั่วไปความแม่นยำของการคาดการณ์สภาวะฝนจะลดลงเมื่อระยะเวลาคาดการณ์ยาวขึ้น โดยจะมีความแม่นยำสูงสุดที่ 3 วันข้างหน้า โปรดใช้วิจารณญาณในการนำข้อมูลไปใช้': '* โดยทั่วไปความแม่นยำของการคาดการณ์สภาวะฝนจะลดลงเมื่อระยะเวลาคาดการณ์ยาวขึ้น โดยจะมีความแม่นยำสูงสุดที่ 3 วันข้างหน้า โปรดใช้วิจารณญาณในการนำข้อมูลไปใช้',
    'เปรียบเทียบ แผนภาพคาดการณ์ฝน': 'เปรียบเทียบ แผนภาพคาดการณ์ฝน',
    'เปรียบเทียบ แผนภาพคาดการณ์ฝน WRF-ROMS Model กับ TMD-WRF Model': 'เปรียบเทียบ แผนภาพคาดการณ์ฝน WRF-ROMS Model กับ TMD-WRF Model',
    'เกณฑ์คาดการณ์ฝน': 'เกณฑ์คาดการณ์ฝน',
    'กองพยากรณ์อากาศ กรมอุตุนิยมวิทยา': 'กองพยากรณ์อากาศ กรมอุตุนิยมวิทยา',
    'MSLP และ precipitation 24 ชม. จัดทำโดย กองพยากรณ์อากาศ กรมอุตุนิยมวิทยา': 'MSLP และ precipitation 24 ชม. จัดทำโดย กองพยากรณ์อากาศ กรมอุตุนิยมวิทยา',
    'แผนภาพคาดการณ์ฝน ล่วงหน้า 7 วัน': 'แผนภาพคาดการณ์ฝน ล่วงหน้า 7 วัน',
    'ล่วงหน้า 7 วัน': 'ล่วงหน้า 7 วัน',
    'เปรียบเทียบ': 'เปรียบเทียบ',

    // table
    'ค้นหา': 'ค้นหา',
    'ชื่อสถานี': 'ชื่อสถานี',
    'สถานี': 'สถานี',
    'ที่ตั้ง': 'ที่ตั้ง',
    'เวลา': 'เวลา',
    'แถว': 'แถว',
    'หน้าแรก': 'หน้าแรก',
    'หน้าสุดท้าย': 'หน้าสุดท้าย',
    'ก่อนหน้า': 'ก่อนหน้า',
    'ถัดไป': 'ถัดไป',
    'ไม่มีข้อมูลตามเงื่อนไข': 'ไม่มีข้อมูลตามเงื่อนไข',
    'กำลังโหลดข้อมูล...': 'กำลังโหลดข้อมูล...',

    // map
    'เส้นแม่น้ำ': 'เส้นแม่น้ำ',
    'ขอบเขตการปกครอง': 'ขอบเขตการปกครอง',
    'ขอบเขตลุ่มน้ำ': 'ขอบเขตลุ่มน้ำ',
    'แสดงเต็มหน้าจอ': 'แสดงเต็มหน้าจอ',
    'แม่น้ำ': 'แม่น้ำ',
    'แผนที่': 'แผนที่',

    // common
    'ล่าสุด': 'ล่าสุด',
    'ข้อมูลจาก': 'ข้อมูลจาก',
    'ข้อมูล': 'ข้อมูล',
    'ที่มา': 'ที่มา',
    'ภาพเคลื่อนไหว': 'ภาพเคลื่อนไหว',
    'กราฟ': 'กราฟ',
    'ไม่มีข้อมูล': 'ไม่มีข้อมูล',
    'ไม่มีข้อมูลในช่วงเวลาที่เลือก': 'ไม่มีข้อมูลในช่วงเวลาที่เลือก',
    'วันที่เริ่มต้น': 'วันที่เริ่มต้น',
    'วันที่สิ้นสุด': 'วันที่สิ้นสุด',
    'หน่วย': 'หน่วย',
    'ข้อมูลวันที่': 'ข้อมูลวันที่',
    'ความหมาย': 'ความหมาย',
    'วันที่': 'วันที่',
    'สี': 'สี',
    'ตำบล': 'ตำบล',
    'อำเภอ': 'อำเภอ',
    'จังหวัด': 'จังหวัด',
    'ต.': 'ต.',
    'อ.': 'อ.',
    'จ.': 'จ.',
    'น.': 'น.',
    'ลุ่มน้ำ': 'ลุ่มน้ำ',
    'ทั่วประเทศ': 'ทั่วประเทศ',
    'ทุกลุ่มน้ำ': 'ทุกลุ่มน้ำ',
    'ค่า': 'ค่า',
    'เมตร': 'เมตร',
    'ดาวน์โหลด': 'ดาวน์โหลด',
    'แสดง': 'แสดง',
    'เปลี่ยนภาษา': 'เปลี่ยนภาษา',
    'เลือก': 'เลือก',
    'ดูภาพล่าสุด': 'ดูภาพล่าสุด',
    'ดูภาพย้อนหลัง': 'ดูภาพย้อนหลัง',

    // rule
    'น้อยวิกฤต': 'น้อยวิกฤต',
    'น้อย': 'น้อย',
    'ปกติ': 'ปกติ',
    'มาก': 'มาก',
    'เกินความจุ': 'เกินความจุ',
    'ฝนเล็กน้อย': 'ฝนเล็กน้อย',
    'ฝนปานกลาง': 'ฝนปานกลาง',
    'ฝนหนัก': 'ฝนหนัก',
    'ฝนหนักมาก': 'ฝนหนักมาก',
    'เฝ้าระวังพิเศษ': 'เฝ้าระวังพิเศษ',
    'วิกฤต': 'วิกฤต',
    'นับเฉพาะขั้น': 'นับเฉพาะขั้น',
    'น้ำน้อยวิกฤติ': 'น้ำน้อยวิกฤติ',
    'น้ำล้นตลิ่ง': 'น้ำล้นตลิ่ง',
    'เขื่อนน้ำน้อยวิกฤต (%ใช้การฯ)': 'เขื่อนน้ำน้อยวิกฤต (%ใช้การฯ)',
    'เขื่อนน้ำมากวิกฤต (% รนก.)': 'เขื่อนน้ำมากวิกฤต (% รนก.)',
    'มากกว่า 2 กรัม ต่อลิตร': 'มากกว่า 2 กรัม ต่อลิตร',
    'มากกว่า 0.50 กรัม ต่อลิตร': 'มากกว่า 0.50 กรัม ต่อลิตร',
    'มากกว่า 0.25 กรัม ต่อลิตร': 'มากกว่า 0.25 กรัม ต่อลิตร',
    'เกินมาตรฐานคุณภาพเพื่อการผลิตน้ำประปา': 'เกินมาตรฐานคุณภาพเพื่อการผลิตน้ำประปา',
    'เกินมาตรฐานคุณภาพเพื่อการเกษตร': 'เกินมาตรฐานคุณภาพเพื่อการเกษตร',
    'เฝ้าระวังคุณภาพน้ำดินเพื่อผลิตน้ำประปา': 'เฝ้าระวังคุณภาพน้ำดินเพื่อผลิตน้ำประปา',
    'น้ำน้อย': 'น้ำน้อย',
    'น้ำน้อยวิกฤต': 'น้ำน้อยวิกฤต',
    'น้ำปานกลาง': 'น้ำปานกลาง',
    'น้ำมาก': 'น้ำมาก',

    // full map
    'แจ้งเตือนสถานการณ์"คาดการณ์ความเค็ม"ล่าสุด': 'แจ้งเตือนสถานการณ์"คาดการณ์ความเค็ม"ล่าสุด',
    'แจ้งเตือนสถานการณ์"ติดตามภัยแล้ง"ล่าสุด': 'แจ้งเตือนสถานการณ์"ติดตามภัยแล้ง"ล่าสุด',
    'ปริมาณฝนสะสม 15 วันย้อนหลัง (มม.)': 'ปริมาณฝนสะสม 15 วันย้อนหลัง (มม.)',
    'ปริมาณฝนสะสมคาดการณ์ล่วงหน้า 7 วัน (มม.)': 'ปริมาณฝนสะสมคาดการณ์ล่วงหน้า 7 วัน (มม.)',
    'ค่าความเค็มสูงสุด': 'ค่าความเค็มสูงสุด',
    'สถานการณ์น้ำประเทศไทย': 'สถานการณ์น้ำประเทศไทย',
    'แจ้งเตือนสถานการณ์"คุณภาพน้ำ"ล่าสุด': 'แจ้งเตือนสถานการณ์"คุณภาพน้ำ"ล่าสุด',
    'แจ้งเตือนสถานการณ์"แหล่งน้ำขนาดใหญ่"ล่าสุด': 'แจ้งเตือนสถานการณ์"แหล่งน้ำขนาดใหญ่"ล่าสุด',
    'ฝนสะสม 1 วันล่วงหน้า': 'ฝนสะสม 1 วันล่วงหน้า',
    'สถานีโทรมาตรเพื่อติดตามสถานการณ์': 'สถานีโทรมาตรเพื่อติดตามสถานการณ์',
    'ความสูงของคลื่น': 'ความสูงของคลื่น',

    // month
    'มกราคม': 'มกราคม',
    'กุมภาพันธ์': 'กุมภาพันธ์',
    'มีนาคม': 'มีนาคม',
    'เมษายน': 'เมษายน',
    'พฤษภาคม': 'พฤษภาคม',
    'มิถุนายน': 'มิถุนายน',
    'กรกฏาคม': 'กรกฏาคม',
    'สิงหาคม': 'สิงหาคม',
    'กันยายน': 'กันยายน',
    'ตุลาคม': 'ตุลาคม',
    'พฤศจิกายน': 'พฤศจิกายน',
    'ธันวาคม': 'ธันวาคม',

    // credit
    'ข้อมูลจากกรมชลประทาน': 'ข้อมูลจากกรมชลประทาน',

    // province
    'กรุงเทพมหานคร': 'กรุงเทพมหานคร',
    'อำนาจเจริญ': 'อำนาจเจริญ',
    'อ่างทอง': 'อ่างทอง',
    'บึงกาฬ': 'บึงกาฬ',
    'บุรีรัมย์': 'บุรีรัมย์',
    'ฉะเชิงเทรา': 'ฉะเชิงเทรา',
    'ชัยนาท': 'ชัยนาท',
    'ชัยภูมิ': 'ชัยภูมิ',
    'จันทบุรี': 'จันทบุรี',
    'เชียงใหม่': 'เชียงใหม่',
    'เชียงราย': 'เชียงราย',
    'ชลบุรี': 'ชลบุรี',
    'ชุมพร': 'ชุมพร',
    'กาฬสินธุ์': 'กาฬสินธุ์',
    'กำแพงเพชร': 'กำแพงเพชร',
    'กาญจนบุรี': 'กาญจนบุรี',
    'ขอนแก่น': 'ขอนแก่น',
    'กระบี่': 'กระบี่',
    'ลำปาง': 'ลำปาง',
    'ลำพูน': 'ลำพูน',
    'เลย': 'เลย',
    'ลพบุรี': 'ลพบุรี',
    'แม่ฮ่องสอน': 'แม่ฮ่องสอน',
    'มหาสารคาม': 'มหาสารคาม',
    'มุกดาหาร': 'มุกดาหาร',
    'นครนายก': 'นครนายก',
    'นครปฐม': 'นครปฐม',
    'นครพนม': 'นครพนม',
    'นครราชสีมา': 'นครราชสีมา',
    'นครสวรรค์': 'นครสวรรค์',
    'นครศรีธรรมราช': 'นครศรีธรรมราช',
    'น่าน': 'น่าน',
    'นราธิวาส': 'นราธิวาส',
    'หนองบัวลำภู': 'หนองบัวลำภู',
    'หนองคาย': 'หนองคาย',
    'นนทบุรี': 'นนทบุรี',
    'ปทุมธานี': 'ปทุมธานี',
    'ปัตตานี': 'ปัตตานี',
    'พังงา': 'พังงา',
    'พัทลุง': 'พัทลุง',
    'พะเยา': 'พะเยา',
    'เพชรบูรณ์': 'เพชรบูรณ์',
    'เพชรบุรี': 'เพชรบุรี',
    'พิจิตร': 'พิจิตร',
    'พิษณุโลก': 'พิษณุโลก',
    'พระนครศรีอยุธยา': 'พระนครศรีอยุธยา',
    'แพร่': 'แพร่',
    'ภูเก็ต': 'ภูเก็ต',
    'ปราจีนบุรี': 'ปราจีนบุรี',
    'ประจวบคีรีขันธ์': 'ประจวบคีรีขันธ์',
    'ระนอง': 'ระนอง',
    'ราชบุรี': 'ราชบุรี',
    'ระยอง': 'ระยอง',
    'ร้อยเอ็ด': 'ร้อยเอ็ด',
    'สระแก้ว': 'สระแก้ว',
    'สกลนคร': 'สกลนคร',
    'สมุทรปราการ': 'สมุทรปราการ',
    'สมุทรสาคร': 'สมุทรสาคร',
    'สมุทรสงคราม': 'สมุทรสงคราม',
    'สระบุรี': 'สระบุรี',
    'สตูล': 'สตูล',
    'สิงห์บุรี': 'สิงห์บุรี',
    'ศรีสะเกษ': 'ศรีสะเกษ',
    'สงขลา': 'สงขลา',
    'สุโขทัย': 'สุโขทัย',
    'สุพรรณบุรี': 'สุพรรณบุรี',
    'สุราษฎร์ธานี': 'สุราษฎร์ธานี',
    'สุรินทร์': 'สุรินทร์',
    'ตาก': 'ตาก',
    'ตรัง': 'ตรัง',
    'ตราด': 'ตราด',
    'อุบลราชธานี': 'อุบลราชธานี',
    'อุดรธานี': 'อุดรธานี',
    'อุทัยธานี': 'อุทัยธานี',
    'อุตรดิตถ์': 'อุตรดิตถ์',
    'ยะลา': 'ยะลา',
    'ยโสธร': 'ยโสธร',
    'อื่นๆ': 'อื่นๆ',

    // basin
    'โขงตะวันออกเฉียงเหนือ': 'โขงตะวันออกเฉียงเหนือ',
    'โขงเหนือ': 'โขงเหนือ',
    'เจ้าพระยา': 'เจ้าพระยา',
    'ชายฝั่งทะเลตะวันออก': 'ชายฝั่งทะเลตะวันออก',
    'ชี': 'ชี',
    'โตนเลสาป': 'โตนเลสาป',
    'ทะเลสาบสงขลา': 'ทะเลสาบสงขลา',
    'ท่าจีน': 'ท่าจีน',
    'บางปะกง': 'บางปะกง',
    'ป่าสัก': 'ป่าสัก',
    'ปิง': 'ปิง',
    'เพชรบุรี-ประจวบคีรีขันธ์': 'เพชรบุรี-ประจวบคีรีขันธ์',
    'ภาคใต้ฝั่งตะวันตก': 'ภาคใต้ฝั่งตะวันตก',
    'ภาคใต้ฝั่งตะวันออกตอนบน': 'ภาคใต้ฝั่งตะวันออกตอนบน',
    'ภาคใต้ฝั่งตะวันออกตอนล่าง': 'ภาคใต้ฝั่งตะวันออกตอนล่าง',
    'มูล': 'มูล',
    'แม่กลอง': 'แม่กลอง',
    'ยม': 'ยม',
    'วัง': 'วัง',
    'สะแกกรัง': 'สะแกกรัง',
    'สาละวิน': 'สาละวิน',
  },
};

export default th;
